const Validator = {
    isEmpty: (input) => {
        return input == null || input.toString().trim() === "";
    },

    isEmail: (input) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input);
    },

    isPostalCode: (input) => {
        return /^\d{2}-\d{3}$/.test(input);
    },

    isNIP: (input) => {
        return /^\d{10}$/.test(input);
    },

    isPhone: (input) => {
        return /^\+\d{6,15}$/.test(input);
    },

    isStrongPassword: (input) => {
        if (typeof input !== "string") return false;
        const hasMinLength = input.length >= 8;
        const hasNumber = /\d/.test(input);
        const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>_\-+=/\\[\]~`]/.test(input);
        return hasMinLength && hasNumber && hasSpecialChar;
    }
};

export default Validator;